import { useEffect,useState } from "react";

import { ToastContainer } from 'react-toastify';
import Snowfall from 'react-snowfall'
import {Outlet, ScrollRestoration} from "react-router-dom";
import {Nav,Footer} from "../../Module_Exporter/Module_Exporter";
import { whatsappNumber,whatsappNumberurl } from "../../functions/DefaultValues";


function Root() 
{
  const [active_sticky_navbar,set_navbar_mode]=useState(false);



  useEffect(()=>{
    window.addEventListener("scroll",(e)=>{
      //  console.log(window.scrollY);
      if( window.scrollY>=110)
      {

        set_navbar_mode(true);
       
     

      }
   
      else if(window.scrollY<=0)     
      {
       
        set_navbar_mode(false);
      }
     
    })  
   })

  return<>
<Nav  sticky={active_sticky_navbar} />
{/* <div className="rapper"> */}

<Outlet/>
<ToastContainer/>
<ScrollRestoration />
<div id="snow_fall_container">
    <Snowfall  snowflakeCount={15} color="#ffffff9d"
   />
  </div>


<Footer/>
<a href={"https://wa.me/"+whatsappNumberurl} rel=" noopener  author noreferrer" target="_blank" id="whatsApp_Icon"><i className="fab fa-whatsapp"></i></a>

{/* </div> */}
  </>
  
}

export default Root;